import { Component, Input, HostBinding } from '@angular/core';
import { PostType } from '../../../../models/post-overview';
import { StringUtils } from '../../../utils/string.utils';

@Component({
    selector: 'post-type-display',
    templateUrl: './post-type-display.component.html',
    styleUrls: ['./post-type-display.component.scss']
})
export class PostTypeDisplayComponent {
    private _postType: PostType;

    @Input() set postType(value: PostType) {
        this._postType = value;
        this.hasValue = !StringUtils.isUndefinedNullOrEmpty(value);
    }
    get postType(): PostType {
        return this._postType;
    }

    @HostBinding('class.has-value')
    public hasValue;

    @HostBinding('class.borderless')
    @Input()
    borderless: boolean;
}



// WEBPACK FOOTER //
// ./src/app/main/post-overview/post-type-display/post-type-display.component.ts